var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDropbox = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M14.432 5.607L18 3.017 12.926 0 9.317 2.38 5.708 0 0 2.988l3.614 2.755-3.01 2.743 2.96 1.71v1.188c0 .09.06.18.15.24l5.04 3.254a.354.354 0 0 0 .095.092c.06.03.09.03.151.03.037 0 .062 0 .09-.02a.208.208 0 0 0 .061-.04l5.134-3.287c.09-.03.151-.149.151-.239v-1.42l2.96-1.866-2.964-2.521zM8.989 8.364L4.691 5.741l4.604-2.657 4.028 2.517-4.334 2.763zm2.97 2.483L9.514 8.755l4.38-2.779 2.476 2.122-4.41 2.749zm.967-10.13l3.987 2.36-2.95 2.131-.01-.009-.077.05-4.016-2.49.016-.01-.015-.01L12.926.717zm-7.278 0l3.08 2.032-4.62 2.63-3.02-2.271 4.56-2.39zm-1.51 5.379l4.347 2.64-2.384 2.2-2.084-1.195a.265.265 0 0 0-.05-.025L1.63 8.366l2.507-2.27zm.03 4.452l1.812 1.046c.023.017.046.03.07.038l.141.081.915-.846 1.592-1.455v4.751l-4.53-2.928v-.687zm7.913.956l1.751-1.106v.867l-4.53 2.898v-4.78l2.416 2.091a.244.244 0 0 0 .116.063l.065.057.092-.058a.408.408 0 0 0 .09-.032z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDropbox, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dropbox.9ab46ebb.svg";
export { ForwardRef as ReactComponent };